import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_3 = { class: "min-w-0 truncate" }
const _hoisted_4 = { class: "shrink-0 text-catering-ink-700" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = { class: "mt-1 flex flex-wrap gap-1" }


export default {
  __name: 'BotTaxSetup',
  props: { block: { type: Object, required: true } },
  setup(__props) {


function taxLabel(structure) {
  if (structure === 'none') return 'No tax'
  if (structure === 'taxjar') return 'TaxJar (automatic)'
  if (structure === 'manual') return 'Manual per-state'
  return structure
}
function formatRate(rate) {
  const num = Number(rate)
  if (!Number.isFinite(num)) return rate
  return `${Math.round(num * 100) / 100}%`
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Tax setup", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.stores || [], (s, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "flex items-center justify-between py-1 text-catering-ink-900"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(s.store_name), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(taxLabel(s.tax_structure)), 1)
        ]))
      }), 128))
    ]),
    ((__props.block.manual_state_rates || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-[11px] font-semibold uppercase tracking-wide text-catering-honey-600" }, "Manual state rates", -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.manual_state_rates, (r, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
              }, _toDisplayString(r.state) + " " + _toDisplayString(formatRate(r.rate)), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}